import apiClient from 'utilities/apiClient';

export const create_sieve_label = (payload) => {
  return apiClient.post(`${apiClient.Urls.sieveLabels}`, payload, true);
};

export const regenerate_missing_sieve_pdfs = () => {
  return apiClient.post(
    `${apiClient.Urls.sieveLabels}/regenerate-missing`,
    {},
    true
  );
};

export const get_sieve_labels = (payload) => {
  return apiClient.get(`${apiClient.Urls.sieveLabels}`, payload, true);
};

export const get_sieve_label = (id) => {
  return apiClient.get(`${apiClient.Urls.sieveLabels}/${id}`, {}, true);
};

export const clean_sieve = (id) => {
  return apiClient.patch(`${apiClient.Urls.sieveLabels}/${id}/clean`, {}, true);
};

export const allocate_sieve_batch = (id, payload) => {
  return apiClient.patch(
    `${apiClient.Urls.sieveLabels}/${id}/allocate`,
    payload,
    true
  );
};

export const change_sieve_status = (id) => {
  return apiClient.patch(
    `${apiClient.Urls.sieveLabels}/${id}/status-change`,
    {},
    true
  );
};

export const get_sieve_counts = () => {
  return apiClient.get(`${apiClient.Urls.sieveLabels}/counts`, {}, true);
};

export const get_sieve_logs = (sieveLabelNumber) => {
  return apiClient.get(
    `${apiClient.Urls.sieveLabels}/${sieveLabelNumber}/logs`,
    {},
    true
  );
};

export const bulk_clean_sieves = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.sieveLabels}/bulk-clean`,
    payload,
    true
  );
};

export const bulk_allocate_sieves = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.sieveLabels}/bulk-allocate`,
    payload,
    true
  );
};

export const bulk_status_change_sieves = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.sieveLabels}/bulk-status-change`,
    payload,
    true
  );
};

export const generate_sieve_usage_log_report = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.sieveLabels}/usage-log-report`,
    payload,
    true
  );
};

export const bulkInactivateSievesApi = (payload) =>
  apiClient.post(
    `${apiClient.Urls.sieveLabels}/bulk-inactivate`,
    payload,
    true
  );

export const reactivateSieveApi = ({ sieve_label_number, note }) =>
  apiClient.post(
    `${apiClient.Urls.sieveLabels}/${sieve_label_number}/reactivate`,
    { note },
    true
  );
